import React, { useState } from "react";
import styled from "@emotion/styled";
import Button from "~/components/button";
import HelpWidgetForm from "./HelpWidgetForm";

const HelpButton = styled(Button)`
  min-width: unset;
  width: 30px;
  .material-icons {
    color: white;
    font-size: 22px;
    width: 22px;
    height: 22px;
    margin-top: -2px;
    margin-bottom: -2px;
  }
`;

const HelpWidget: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <HelpButton
        onClick={() => setOpen(true)}
        className="help-widget"
        icon="help_outline"
      />
      <HelpWidgetForm {...{ open, setOpen }} />
    </>
  );
};

export default HelpWidget;
